export default __webpack_public_path__ + "static/DSC_0439-71c31dddd7cd719393550f380f323cea.jpg";